import React, {useState, useCallback} from 'react'

export default function UseHover() {
  const [isHovered, setHover] = useState(false)
  const hover = useCallback((e) => (e.stopPropagation(), setHover(true)), [])
  const unhover = useCallback((e) => setHover(false), [])
  return [{ onPointerOver: hover, onPointerOut: unhover }, isHovered]
}


